export default __webpack_public_path__ + "static/media/BNB.1b850d1e.svg";